import React, { useEffect } from 'react';

import Header from 'src/features/motionResult/Header';
import MotionList from 'src/features/motionResult/MotionList';
import styled from 'styled-components';

const MotionResultStyled = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export default function MotionResult() {
  useEffect(() => {
    localStorage.setItem('timer', `${new Date().getTime()}`);
  }, []);
  return (
    <MotionResultStyled>
      <Header />
      <MotionList />
    </MotionResultStyled>
  );
}
